// extracted by mini-css-extract-plugin
export var brand = "_1j-8";
export var compact = "_1j-5";
export var extraSmall = "_1j-6";
export var icon = "_1j-0";
export var large = "_1j-3";
export var light = "_1j-1";
export var medium = "_1j-4";
export var outline = "_1j-a";
export var primaryDark = "_1j-9";
export var primaryLight = "_1j-7";
export var primaryModern = "_1j-b";
export var success = "_1j-2";